module.exports = __webpack_public_path__ + "nc_static/media/question-mark.svg.fd51a7dc.icon";